/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { memo } from 'react';

import JiraTopBanner from '@post-office-placement/jira-top-banner/placement';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { postOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { PostOfficeProvider } from '@jira/post-office__post-office-provider/src/index.tsx';
import { PlacementFetchProvider } from '@jira/post-office__post-office-provider/src/placement-fetch-provider.tsx';
import killswitch from '@jira/platform__utils-feature-gates-killswitch/src/index.tsx';

import { Placement } from '@atlassian/post-office-placement';

const PLACEMENT_ID = 'jira-top-banner';

const TopBannerPlacement = () => {
	return (
		<JSErrorBoundary
			id="topBannerPlacement"
			packageName="top-banner-placement"
			teamName="post-office"
			fallback={() => <></>}
		>
			<PostOfficeProvider>
				{/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */}
				<div data-testid="top-banner-placement.jira-top-banner-placement">
					<PlacementFetchProvider resource={postOfficeJiraTopBannerResource}>
						<Placement
							placementId={PLACEMENT_ID}
							// Post Office and Jira uses different versions of react-error-boundary - https://atlassian.slack.com/archives/CL6HC337Z/p1741218999095929
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
							PlacementComponent={JiraTopBanner}
						/>
					</PlacementFetchProvider>
				</div>
			</PostOfficeProvider>
		</JSErrorBoundary>
	);
};

export const JiraTopBannerPlacement: React.MemoExoticComponent<() => React.JSX.Element | null> =
	memo((): React.JSX.Element | null => {
		if (!killswitch('killswitch_post_office_in_jira') && fg('jira-issue-term-refresh-banner')) {
			return <TopBannerPlacement />;
		}

		return null;
	});
